var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.1667 45.8334V37.5C79.1667 35.2899 78.2887 33.1703 76.7259 31.6075C75.1631 30.0447 73.0435 29.1667 70.8334 29.1667H37.5C35.2899 29.1667 33.1703 30.0447 31.6075 31.6075C30.0447 33.1703 29.1667 35.2899 29.1667 37.5V70.8334C29.1667 73.0435 30.0447 75.1631 31.6075 76.7259C33.1703 78.2887 35.2899 79.1667 37.5 79.1667H45.8334",
    stroke: "#A4A4A4",
    strokeWidth: 8.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5V12.5417M29.1667 12.5V12.5417M45.8333 12.5V12.5417M62.5 12.5V12.5417M12.5 29.1667V29.2083M12.5 45.8333V45.875M12.5 62.5V62.5417M54.1667 54.1667L91.6667 66.6667L75 75L66.6667 91.6667L54.1667 54.1667Z",
    stroke: "#A4A4A4",
    strokeWidth: 8.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag_icon.b37ffb5a6e680444d29a36b11d57f5f1.svg";
export { ForwardRef as ReactComponent };